import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { PipesModule } from '@fuse/pipes/pipes.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { ShowDataInputModule } from '../../../../../../core/components/show-data-input/show-data-input.module';
import { StarsModule } from '../logs/stars/stars.module';
import { TabTasksComponent } from './tab-tasks.component';


@NgModule({
  entryComponents: [
    TabTasksComponent
  ],
  declarations: [
    TabTasksComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    FuseSharedModule,
    MatIconModule,
    ShowDataInputModule,
    StarsModule,
    PipesModule
  ],
  exports: [
    TabTasksComponent
  ]
})
export class TabTasksModule {
}
